import FlexContainer from '@powerednow/components/FlexContainer/FlexContainer';
import React from 'react';
import Optional from '@powerednow/components/fields/Optional';
import DocumentEntity from '@powerednow/models/document/entity';
import PurchaseOrderCard from './PurchaseOrderCard';

interface PurchaseOrderListProps {
    documents: DocumentEntity[],
    onCardClick: (document: DocumentEntity) => void
}

function PurchaseOrderList({ documents, onCardClick }:PurchaseOrderListProps) {
    return (
        <FlexContainer mt={4}>
            {documents.map((document, index) => (
                <PurchaseOrderCard
                    key={`purchaseOrder-card-${document.id}`}
                    purchaseOrder={document}
                    onClick={() => onCardClick(document)}
                />
            ))}
        </FlexContainer>
    );
}

const OptionalPurchaseOrderList = Optional(PurchaseOrderList);

export default OptionalPurchaseOrderList;
